export const ESCALATION_ORDER_LIST_REQUEST = 'ESCALATION_ORDER_LIST_REQUEST';
export const ESCALATION_ORDER_LIST_SUCCESS = 'ESCALATION_ORDER_LIST_SUCCESS';
export const ESCALATION_ORDER_LIST_FAIL = 'ESCALATION_ORDER_LIST_FAIL';